export { default } from './FormKioskDevice.vue'
